import { Platform } from "react-native";
import { useFeatureFlags, getBooleanFlag, FEATURE_FLAGS } from "@src/services/feature-flags/feature-flags";

/**
 * Legacy Auth Hook (reactive)
 *
 * Determines which authentication flow to use based on feature flags.
 * Subscribes to flag store changes so the UI reacts automatically.
 *
 * Amplitude feature flag "legacy_auth":
 *    - true: Use legacy Django API authentication
 *    - false: Use Auth0 authentication
 *
 * Note: Web platform always uses Auth0 (returns false)
 */
export const useLegacyAuth = (): boolean => {
  const { getBooleanFlag } = useFeatureFlags();
  // Web always uses Auth0
  if (Platform.OS === "web") return false;
  return getBooleanFlag(FEATURE_FLAGS.LEGACY_AUTH, true);
};

/**
 * Non-reactive getter for imperative (non-React) code.
 * Reads the current snapshot from the store.
 */
export const getUseLegacyAuth = (): boolean => {
  if (Platform.OS === "web") return false;
  return getBooleanFlag(FEATURE_FLAGS.LEGACY_AUTH, true);
};
